<template>
  <div class="banner home" :class="{ mobileBanner: isMobile }">
    <el-carousel
      v-if="!isMobile"
      style="carousel-box"
      :height="controlHeight"
      :autoplay="true"
      :interval="5000"
      arrow="always"
    >
      <el-carousel-item class="list1">
        <div class="banner-1 bg-video">
          <video
            ref="homeVideo"
            webkit-playsinline="true"
            x-webkit-airplay="true"
            playsinline="true"
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            preload="auto"
            autoplay
            class="v1"
            loop
            muted
          >
            <source src="@/static/movie/bg.mp4" />
          </video>
          <div class="layour">
            <div class="inner">
              <div class="box1">
                <img src="@/static/images/home-logo.png" />
              </div>
              <div class="text">
                <div class="text1">智能在线考试专家</div>
                <div class="text2">考试选拔，从此变得如此简单</div>
              </div>
              <div class="info">
                <i class="iconfont iconlifangti3"></i>
                阿里、京东、头条、美团、滴滴、小米等公司校招考试都在用
              </div>
              <div class="btns-info">
                <a @click="goTest" class="btn-blue-hover">试用</a
                ><a @click="chatShow">咨询顾问</a>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="banner-2">
          <div class="layour">
            <div class="inner">
              <div class="text">
                <div class="text1" style="margin-top: -10px">
                  在线考试无法解决防作弊？
                </div>
                <div class="text2">
                  赛码AI智能防作弊系统，让作弊考生无处遁行
                </div>
              </div>
              <div class="btns-info">
                <a @click="goTest" class="white">试用</a
                ><a @click="chatShow">咨询顾问</a>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="banner-3">
          <div class="layour">
            <div class="inner">
              <div class="text">
                <div class="text1">
                  <span>曾经，</span>我们只承接万人以上的大型在线考试
                  <br />
                  <span>现在，</span>我们也为中小型客户提供更优质的服务。
                </div>
                <div class="text2">赛码：互联网Top50+企业校招指定考试平台</div>
              </div>
              <div class="btns-info">
                <a @click="goTest" class="btn-blue-hover">试用</a
                ><a @click="chatShow">咨询顾问</a>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="banner-4">
          <div class="layour">
            <div class="inner">
              <div class="text">
                <div class="text1">
                  考完如何面试？<br />
                  赛码视频面试系统，一站式解决您的所有问题
                </div>
                <div class="text2">距离不再遥远，人才近在眼前</div>
              </div>
              <div class="btns-info">
                <a @click="goTest" class="white">试用</a
                ><a @click="chatShow">咨询顾问</a>
              </div>
            </div>
          </div>
          <div class="lines">
            <lineControl class="line1"></lineControl>
            <lineControl class="line2"></lineControl>
            <lineControl class="line3"></lineControl>
            <lineControl class="line4"></lineControl>
            <lineControl class="line5"></lineControl>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div v-if="isMobile">
      <div class="banner-5">
        <div class="layour">
          <div class="box1">
            <img src="@/static/images/home-logo.png" />
          </div>
          <div class="text">
            <div class="text1">智能在线考试专家</div>
            <div class="text2">考试选拔，从此变得如此简单</div>
          </div>
          <div class="info">
            阿里、京东、头条、美团、<br />滴滴、小米等公司校招考试都在用
          </div>
          <div class="btns-info">
            <a @click="goTest" class="check">试用</a
            ><a @click="chatShow" class="nocheck">咨询顾问</a>
          </div>
        </div>
      </div>
    </div>
    <us-pc-dialog
      :dialogVisible="isPcDialogShow"
      @cancel="isPcDialogShow = false"
    />
  </div>
</template>

<script>
import lineControl from '@/components/home/carousel/line-animate'
export default {
  components: {
    lineControl,
  },
  data() {
    return {
      isMobile: false,
      controlHeight: '680px',
      isPcDialogShow: false,
    }
  },
  created() {
    this.isMobile = this.$store.state.app.device
  },
  methods: {
    goTest() {
      if (this.isMobile) {
        this.isPcDialogShow = true
      } else {
        //直接干到注册页
        this.$bus.emit('compRegisterChoose')
      }
    },
    chatShow() {
      this.$bus.emit('chatShow')
    },
    resetHeight() {
      if (this.isMobile) {
        //this.controlHeight = (window.innerHeight - 60) + 'px'
      } else {
        this.controlHeight = window.innerHeight - 60 - 150 + 'px'
      }
    },
    bindResize() {
      window.onresize = this.resetHeight
    },
    videoCheck() {
      if (window.videoCheckTimer) {
        window.clearInterval(window.videoCheckTimer)
      }
      window.videoCheckTimer = window.setInterval(() => {
        const video = this.$refs.homeVideo
        try {
          video.play()
        } catch (e) {}
      }, 1000)
    },
  },
  mounted() {
    this.resetHeight()
    this.bindResize()
    this.videoCheck()
  },
}
</script>

<style lang="scss" scoped>
.banner {
  padding: 0px 0px 0px;
  position: relative;
  img {
    margin: auto;
    width: auto;
    max-width: 100%;
  }
  &.mobileBanner {
    background: url('~@/static/images/home-banner-1-bg.png') no-repeat center top;
  }
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 245px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.bg-video {
  width: 100%;
  height: inherit;
  left: 0px;
  top: 0px;
  z-index: -1;
  vertical-align: bottom;
  display: block;
  position: absolute;
}

.btns-info {
  padding: 50px 0px 0px;
  a {
    font-size: 16px;
    padding: 6px 30px;
    cursor: pointer;
    color: #fff;
    border: 2px solid #fff;
    margin-right: 20px;
    font-weight: 300;
    &:hover,
    &.check {
      border: 2px solid #29bdb9;
      background: #29bdb9;
      color: #fff;
    }
    &.nocheck {
      border: 2px solid #29bdb9;
      background: none;
      color: #29bdb9;
    }
    &:last-child {
      margin-right: 0px;
    }
  }
}

.white {
  background: #fff !important;
  color: #29bdb9 !important;
  padding: 8px 32px !important;
  border: 0 !important;
  &:hover {
    background-color: #f0f0f0 !important;
  }
}
.layour {
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  z-index: 0;
  vertical-align: bottom;
  display: grid;
  position: absolute;
  .inner {
    margin: auto;
  }
  .box1 {
    img {
      height: 75px;
    }
  }
  .text {
    background: url('~@/static/images/home-1-bg.png') no-repeat center center;
    height: 150px;
    padding: 30px 20px 20px;
    color: #fff;
    .text1 {
      font-size: 35px;
    }
    .text2 {
      padding: 10px 0px 0px;
      font-size: 18px;
    }
  }
  .info {
    padding: 20px 0px 0px;
    font-size: 18px;
    font-weight: 300;
    .iconfont {
      color: #29bdb9;
      font-size: 26px;
      position: relative;
      top: 3px;
    }
  }
}

.v1 {
  width: 100%;
  height: auto;
}
.banner-2 {
  background: url('~@/static/images/home-banner-2-bg.png') no-repeat center top;
  background-size: cover;
  height: 100%;
  padding-top: 100px;
  .text {
    background: url('~@/static/images/home-banner-2-text-bg.png') no-repeat center
      center;
    width: 539px;
    height: 287px;
    margin: 0px auto 0px;
    padding: 95px 10px 0px 10px;
    color: #29bdb9;
    .text1 {
      font-size: 38px;
      padding: 0px 0px 0px 15px;
    }
    .text2 {
      font-size: 22px;
    }
  }
  .btns-info {
    padding: 0px;
    a {
      &:hover {
        border: 2px solid #fff;
        background: #fff;
        color: #29bdb9;
      }
    }
  }
}
.banner-3 {
  background: url('~@/static/images/home-banner-3-bg.png') no-repeat center top;
  background-size: cover;
  height: 100%;
  padding-top: 100px;
  .text {
    background: url('~@/static/images/home-banner-3-text-bg.png') no-repeat center
      center;
    width: 901px;
    height: 406px;
    margin: 0px auto 0px;
    padding: 85px 10px 0px 10px;
    color: #29bdb9;
    font-weight: 300;
    .text1 {
      font-size: 29px;
      color: #fff;
      padding: 0px 0px 0px 15px;
      span {
        font-weight: bold;
      }
    }
    .text2 {
      padding: 15px 0px 0px;
      font-size: 18px;
      color: #fff;
    }
  }
  .btns-info {
    margin-top: -120px;
    a {
      background: none;
      border: 2px solid #29bdb9;
      color: #29bdb9;
      &:hover {
        border: 2px solid #29bdb9;
        background: #29bdb9;
        color: #fff;
      }
    }
  }
}
.banner-4 {
  background: url('~@/static/images/home-banner-4-bg.png') no-repeat center top;
  background-size: cover;
  height: 100%;
  padding-top: 0px;
  position: relative;
  .layer4 {
    position: absolute;
    z-index: 1;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
  }
  .text {
    background: url('~@/static/images/home-banner-4-text-bg.png') no-repeat center
      center;
    width: 884px;
    height: 458px;
    margin: 0px auto 0px;
    padding: 148px 10px 0px 10px;
    color: #289fde;
    font-weight: 300;
    position: relative;
    z-index: 9;
    .text1 {
      font-size: 29px;
      color: #289fde;
      padding: 0px 0px 0px 15px;
      font-weight: 400;
      span {
        font-weight: bold;
      }
    }
    .text2 {
      padding: 15px 0px 0px;
      font-size: 18px;
      color: #289fde;
    }
  }
  .btns-info {
    position: relative;
    top: -100px;
    z-index: 9;
    a {
      background: none;
      border: 2px solid #fff;
      color: #fff;
      &:hover {
        border: 2px solid #fff;
        background: #fff;
        color: #289fde;
      }
    }
  }
  .lines {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 0;
    width: 100%;
    .line1 {
      position: absolute;
      left: 150px;
      top: 100px;
    }
    .line2 {
      position: absolute;
      left: 250px;
      top: 300px;
    }
    .line3 {
      position: absolute;
      right: 150px;
      top: 160px;
    }
    .line4 {
      position: absolute;
      right: 300px;
      top: 80px;
    }
    .line5 {
      position: absolute;
      right: 280px;
      top: 360px;
    }
  }
}
.banner-5 {
  .layour {
    .box1 {
      padding-top: 10px;
      height: 60px;
      img {
        height: 60px;
      }
    }
    .text {
      padding: 40px 20px 20px;
      font-weight: 300;
      margin-top: -40px;
      .text1 {
        font-size: 30px;
        padding: 0;
      }
      .text2 {
      }
    }
    .info {
      font-size: 16px;
      text-align: center;
      line-height: 30px;
      margin-top: -80px;
    }
    .btns-info {
      padding: 0;
      margin-top: -40px;
    }
  }
}

.mobileBanner {
  text-align: center;
  .layour {
    padding: 50px 30px 0 30px;
  }
}
</style>
<style lang="scss">
.el-carousel__arrow {
  width: 48px !important;
  height: 48px !important;
  font-size: 26px !important;
}

.home {
  .el-carousel__indicator {
    .el-carousel__button {
      height: 4px;
      transform: skew(-50deg);
      background-color: #fff;
    }
    &.is-active {
      .el-carousel__button {
        background-color: #29bdb9 !important;
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .el-carousel__arrow {
    width: 30px !important;
    height: 30px !important;
    font-size: 14px !important;
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .mobileBanner {
    .layour {
      padding: 130px 0 0 0 !important;
    }
    .banner-5 .layour {
      .info {
        font-size: 18px;
      }
      .box1 img {
        height: 90px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home/carousel.vue